import { Box, SxProps, Theme } from '@mui/material';

import { colors } from '../../constants';

type GradientCircleProps = {
  top?: string;
  right?: string;
  bottom?: string;
  left?: string;
  translateX?: string;
  translateY?: string;
  size?: number;
  blur?: number;
  sx?: SxProps<Theme>;
};

export function GradientCircle({
  top,
  right,
  bottom,
  left,
  translateX,
  translateY,
  size = 500,
  blur = 360,
  sx,
}: GradientCircleProps) {
  const hasTranslate = translateX !== undefined || translateY !== undefined;

  return (
    <Box
      sx={[
        {
          width: size,
          height: size,
          borderRadius: '50%',
          background: colors.orange,
          position: 'absolute',
          pointerEvents: 'none',
          ...(top !== undefined && { top }),
          ...(right !== undefined && { right }),
          ...(bottom !== undefined && { bottom }),
          ...(left !== undefined && { left }),
          ...(hasTranslate && {
            transform: `translate(${translateX ?? '0%'}, ${translateY ?? '0%'})`,
          }),
          filter: `blur(${blur}px)`,
          zIndex: -1,
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    />
  );
}
